import React from 'react';
import { useUser } from '@/contexts/UserContext';
import { AthleteSignalSection } from './AthleteSignalSection';
import { BrandSignalSection } from '@/components/brand/BrandSignalSection';
import { VentureSignalSection } from '@/components/venture/VentureSignalSection';
import { SignalOnboardingTooltip } from '@/components/signal/SignalOnboardingTooltip';

export const EnhancedFeedPage = () => {
  const { accountType } = useUser();

  return (
    <div className="space-y-6 max-w-full overflow-x-hidden">
      <SignalOnboardingTooltip />
      {accountType === 'brand' ? (
        <BrandSignalSection />
      ) : accountType === 'venture' ? (
        <VentureSignalSection />
      ) : (
        <AthleteSignalSection />
      )}
    </div>
  );
};
